import { useState } from "react";
import { PermisoesHelper } from "../../helpers";
import { notification } from "../../services";
import { responseErros } from "../../utils";

export function usePermissaoRetirarBaixa() {
  const [dialogPermissao, setDialogPermissao] = useState({ open: false });
  const permissoesHelper = new PermisoesHelper();

  const mostrarDialogPermissao = () =>
    new Promise((resolve) => {
      const fecharDialog = (autorizado) => {
        setDialogPermissao((prev) => ({ ...prev, open: false }));
        resolve(autorizado);
      };
      setDialogPermissao({
        open: true,
        permissao: "retirar-baixa",
        descricaoPermissao: "retirar baixa",
        onValidate: (autorizado) => {
          if (!autorizado) {
            return notification.alertaGenericos(
              "Usuário sem permissão para retirar baixa",
            );
          }
          fecharDialog(true);
        },
        onClose: () => fecharDialog(false),
      });
    });

  const validarPermissaoRetirarBaixa = async () => {
    const temPermissao = permissoesHelper.temPermisao("retirar-baixa");
    const pedirSenha = permissoesHelper.temPermisao(
      "pedir-senha-retirar-baixa",
    );
    if (temPermissao && !pedirSenha) return true;
    if (!pedirSenha) {
      notification.alertaGenericos("Você não tem permissão para retirar baixa");
      return false;
    }
    return mostrarDialogPermissao();
  };

  const confirmarExclusaoRenegociacao = async (conta, servico) => {
    if (conta.status !== "ABERTO") {
      notification.alertaGenericos(
        "Só é permitido excluir títulos que se encontram em aberto.",
      );
      return false;
    }
    const autorizado = await validarPermissaoRetirarBaixa();
    if (!autorizado) return false;
    const result = await servico.buscarOrigensRenegociacao(conta.id);
    if (result.isAxiosError) {
      responseErros(result);
      return false;
    }
    const titulos = result.data
      .map(({ numeroTitulo }) => `Nº${numeroTitulo}`)
      .join(", ");
    const mensagem =
      result.data.length === 1
        ? `O título ${titulos} de origem dessa renegociação será reaberto e todas as parcelas dela serão excluídas. Tem certeza que deseja excluir?`
        : `Os títulos ${titulos} de origem dessa renegociação serão reabertos e todas as parcelas dela serão excluídas. Tem certeza que deseja excluir?`;
    const retornoAlerta = await notification.confirmacaoExclusao(
      "Excluir!",
      mensagem,
    );
    return retornoAlerta.isConfirmed;
  };

  return {
    dialogPermissao,
    validarPermissaoRetirarBaixa,
    confirmarExclusaoRenegociacao,
  };
}
